import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { Grid } from '@material-ui/core';

const styles = theme => ({
    spacer: {
        marginTop: 25,
    }
});

class AssetPDFPreview extends Component {

    state = {
        numPages: null,
        pageNumber: 1
    }

    render() {
        const { asset_url, classes } = this.props;

        if (this.props.full_page) {
            return (
                <div style={{}} >
                    <Grid container spacing={24}>
                        <Grid xs={2}>
                        </Grid>
                        <Grid xs={8}>
                            <iframe
                                style={{ width: '100%', height: '70vh' }}
                                title="file"
                                src={asset_url}
                            />
                        </Grid>
                    </Grid>
                </div>
            )
        } else {
            return (
                <div className={classNames(classes.spacer)}>
                    <iframe
                        title="file"
                        src={asset_url}
                    >
                    </iframe>
                </div>
            )
        }
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetPDFPreview)));


// WEBPACK FOOTER //
// src/main/content/asset/AssetPDFPreview.js